import { Environment } from '../../env/Environment';
import { Typography } from '../primitives';
import { Trans } from '@rpi/i18n';

export const CheckoutTermsAndConditions = () => {
  return (
    <Typography variant="footnote-2">
      <Trans
        i18nKey="route.checkout.legal"
        components={{
          'terms-link': (
            <a
              aria-label="Terms Link"
              href={Environment.LINK.BLURB_TERMS}
              target="_blank"
              rel="noopener noreferrer"
            />
          ),
          'return-link': (
            <a
              aria-label="return-link"
              href={Environment.LINK.BLURB_RETURNS}
              target="_blank"
              rel="noopener noreferrer"
            />
          ),
        }}
      />
    </Typography>
  );
};
